
import { mapState, mapActions, mapGetters } from "vuex";
import LocationOnlineStatusHandler from "../reciever/location-online-status-handler.vue";
import ResponsiveDialog from "../dialogs/responsive-dialog.vue";
export default {
  components: {
    LocationOnlineStatusHandler,
    ResponsiveDialog
  },
  data() {
    return {
      loading: false,
      planLoading: false,
      selectedPlan: "",
      isSwitchOnline: null
    };
  },
  props: {
    dialog: false,
    isDialogClosable: {
      type: Boolean,
      default: true
    },
    title: ""
  },
  computed: {
    ...mapState("restaurant", [
      "locationDetails",
      "subscription",
      "subscriptionPlans"
    ]),
    isDisabled() {
      return this.selectedPlan === "";
    }
  },
  mounted() {
    this.planLoading = true;
    this.getSubscriptionPlans()
      .then(() => {})
      .finally(() => {
        this.planLoading = false;
      });
    this.isSwitchOnline = this.isLocationOnline;
  },
  methods: {
    ...mapActions("restaurant", [
      "createSubscription",
      "cancelSubscription",
      "getSubscriptionPlans"
    ]),
    ...mapGetters("restaurant", ["isLocationOnline"]),

    handleMakePayment() {
      // if (
      //   !this.subscription ||
      //   !this.subscription.id ||
      //   this.subscription.status == "expired"
      // ) {
      this.loading = true;
      this.createSubscription({
        location_id: this.locationDetails.id,
        plan_id: this.selectedPlan
      }).then(({ data }) => {
        this.$nuxt.$emit("make-payment", data.invoice.id);
        this.$emit("hanldeProceedPayment");
        this.$nuxt.$on("order-placed", () => {
          this.loading = false;
          this.$emit("close-dialog");
        });
      });
      // } else if (this.subscription.plan_name == this.selectedPlan) {
      //   this.$emit("hanldeProceedPayment");
      // } else {
      //   this.loading = true;
      //   this.cancelSubscription()
      //     .then(() => {
      //       this.createSubscription({
      //         restaurant: {
      //           plan: this.selectedPlan
      //         }
      //       }).then(() => {
      //         this.loading = false;
      //         this.$emit("hanldeProceedPayment");
      //       });
      //     })
      //     .catch(function(err) {
      //       this.$nuxt.$emit("show-error-toast", err);
      //     });
      // }
    },
    handleStoreSwitchChange(val) {
      this.isSwitchOnline = val;
    }
  }
};
